export const REVIEW_QUEUE_CHANGED_EVENT = 'lvb:review-queue-changed';

let demandVersion = 1;
let acknowledgedVersion = 0;

export const getReviewQueueVersion = () => demandVersion;

export function countReviewQueueItems(...queues) {
  return queues.reduce(
    (total, queue) => total + (Array.isArray(queue) ? queue.length : 0),
    0,
  );
}

const eventTarget = () => (
  typeof window !== 'undefined' && typeof window.dispatchEvent === 'function'
    ? window
    : null
);

export function markReviewQueueDirty(reason = 'review_queue_changed', opening) {
  demandVersion++;
  const target = eventTarget();
  if (!target) return;
  target.dispatchEvent(new CustomEvent(REVIEW_QUEUE_CHANGED_EVENT, {
    detail: { reason, ...(opening ? { opening } : {}) },
  }));
}

// Callers with asynchronous work must supply the version captured before reading.
export function consumeReviewQueueDirty(version = demandVersion) {
  const wasDirty = isReviewQueueDirty();
  if (Number.isSafeInteger(version) && version >= 0 && version <= demandVersion) {
    acknowledgedVersion = Math.max(acknowledgedVersion, version);
  }
  return wasDirty;
}

export function isReviewQueueDirty() {
  return acknowledgedVersion < demandVersion;
}

export function subscribeToReviewQueueChanges(listener) {
  const target = eventTarget();
  if (!target) return () => {};
  target.addEventListener(REVIEW_QUEUE_CHANGED_EVENT, listener);
  return () => target.removeEventListener(REVIEW_QUEUE_CHANGED_EVENT, listener);
}
